// SetOutOfOffice.tsx
import React, { useState } from 'react';

interface SetOutOfOfficeProps {
    onSuccess: (startDate: string, endDate: string) => void;
    onCancel: () => void;
}

export const SetOutOfOffice = ({ onSuccess, onCancel }: SetOutOfOfficeProps) => {
    const [dates, setDates] = useState({
        startDate: '',
        endDate: ''
    });

    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setDates(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Pass both dates back to the parent component
        onSuccess(dates.startDate, dates.endDate);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-slate-700">
                        Start Date
                    </label>
                    <input
                        type="date"
                        name="startDate"
                        value={dates.startDate}
                        onChange={handleDateChange}
                        required
                        className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-slate-700">
                        End Date
                    </label>
                    <input
                        type="date"
                        name="endDate"
                        value={dates.endDate}
                        onChange={handleDateChange}
                        required
                        min={dates.startDate} // Prevent end date before start date
                        className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm"
                    />
                </div>
            </div>

            <div className="mt-4 flex justify-end space-x-2">
                <button
                    type="button"
                    onClick={onCancel}
                    className="rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
                >
                    Save
                </button>
            </div>
        </form>
    );
};